<template>
  <div class="content_block_container">
    <b-row class="content_block_topbar">
      <b-col><h5 class="title_content_block">Bouton</h5></b-col>
      <b-col style="text-align: right">
        <b-button
          class="controller_button_content"
          @click="$emit('shiftUpBlock', index)"
          ><b-icon icon="caret-up-fill" aria-hidden="true"></b-icon
        ></b-button>
        <b-button
          class="controller_button_content"
          @click="$emit('shiftDownBlock', index)"
          ><b-icon icon="caret-down-fill" aria-hidden="true"></b-icon
        ></b-button>
        <b-button
          class="controller_button_content"
          @click="$emit('deleteBlock', index)"
          ><b-icon icon="trash-fill" aria-hidden="true"></b-icon
        ></b-button>
      </b-col>
    </b-row>
    <b-container class="form_button_content">
      <b-row>
        <b-col sm="3">
          <p>Texte:</p>
        </b-col>
        <b-col sm="6">
          <b-form-input
            v-model="button_property.text"
            placeholder="Url"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="3">
          <p>Url:</p>
        </b-col>
        <b-col sm="6">
          <b-form-input
            v-model="button_property.url"
            placeholder="Url"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="3">
          <p>Couleur de fond:</p>
        </b-col>
        <b-col sm="6">
          <b-form-input
            v-model="button_property.background_color"
            placeholder="Couleur de fond"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="3">
          <p>Couleur du texte:</p>
        </b-col>
        <b-col sm="6">
          <b-form-input
            v-model="button_property.color"
            placeholder="Couleur du texte"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="3">
          <p>Alignement:</p>
        </b-col>
        <b-col sm="6">
          <b-form-select v-model="button_property.alignement" :options="options_align"></b-form-select>
        </b-col>
      </b-row>

      
    </b-container>
    <div class="button_previsualisation_container">
        <p :style="{textAlign : button_property.alignement }">
            <a :href="button_property.url" target="_blank"><button class="button_previ" :style="{color: button_property.color, backgroundColor:button_property.background_color}">{{button_property.text}}</button></a>
            </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["button_property", "index"],
  data() {
    return {
      texte: "Cliquer ici",
      color: "#f29200",
      options_align : [{text : "Gauche", value : "left"},{text : "Centre", value : "center"},{text : "Droite", value : "right"}]
    };
  },
};
</script>

<style>
.button_previsualisation_container{
    margin-top:20px;
    background-color:white;
    padding:20px;
}
.button_previ{
    border:none;
    padding:10px 15px;
    border-radius:5px;
    font-size:16px;
    font-weight:bold;
}

.form_button_content .row{
    margin-top:15px;
}

.form_button_content p{
    text-align:right;
    line-height:38px;
    font-weight:bold;
}

.form_button_content select{
    height:100%;
}
</style>